module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "20",
      "height": "18",
      "viewBox": "0 0 10 10",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.8245 2.5067L5.42271 0.104911C5.35575 0.0379464 5.26535 0 5.17048 0H0.429409C0.231864 0 0.0722656 0.159598 0.0722656 0.357143V9.64286C0.0722656 9.8404 0.231864 10 0.429409 10H7.57227C7.76981 10 7.92941 9.8404 7.92941 9.64286V2.76004C7.92941 2.66518 7.89146 2.57366 7.8245 2.5067ZM7.10575 2.92411H5.0053V0.823661L7.10575 2.92411ZM7.12584 9.19643H0.875837V0.803571H4.24637V3.21429C4.24637 3.33861 4.29576 3.45783 4.38367 3.54574C4.47157 3.63365 4.5908 3.68304 4.71512 3.68304H7.12584V9.19643Z",
      "fill": "#73B8AD"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14f3f9d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/DocumentIcon.vue
// module id = 1475
// module chunks = 159